/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditCardAuthSubmittedResponse
 */
export interface CreditCardAuthSubmittedResponse {
    /**
     * 
     * @type {string}
     * @memberof CreditCardAuthSubmittedResponse
     */
    bookingId: string;
    /**
     * ISO-8601 timestamp the authorization form was submitted.
     * @type {string}
     * @memberof CreditCardAuthSubmittedResponse
     */
    creditCardAuthSubmitted?: string | null;
}

/**
 * Check if a given object implements the CreditCardAuthSubmittedResponse interface.
 */
export function instanceOfCreditCardAuthSubmittedResponse(value: object): value is CreditCardAuthSubmittedResponse {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function CreditCardAuthSubmittedResponseFromJSON(json: any): CreditCardAuthSubmittedResponse {
    return CreditCardAuthSubmittedResponseFromJSONTyped(json, false);
}

export function CreditCardAuthSubmittedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCardAuthSubmittedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'creditCardAuthSubmitted': json['credit_card_auth_submitted'] == null ? undefined : json['credit_card_auth_submitted'],
    };
}

export function CreditCardAuthSubmittedResponseToJSON(json: any): CreditCardAuthSubmittedResponse {
    return CreditCardAuthSubmittedResponseToJSONTyped(json, false);
}

export function CreditCardAuthSubmittedResponseToJSONTyped(value?: CreditCardAuthSubmittedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'credit_card_auth_submitted': value['creditCardAuthSubmitted'],
    };
}

